// Local experiment tools retain their environment gate. A developer feature switched on for this device
// (Screenshot Clean-up) is separately verified-admin + explicit device opt-in.
export function developerToolsAvailable(devServer: boolean, appEnvironment: unknown): boolean {
  return appEnvironment !== 'production' && (devServer || appEnvironment === 'development')
}

// Developer tools need the account's administrator flag (Supabase user_access_profiles.is_admin), even on localhost.
// Bind the asynchronous admin verdict to its account so a user switch fails closed.
export function developerAccessVerified(
  access: 'hidden' | 'checking' | 'admin',
  currentUserId: string | undefined,
  verifiedUserId: string | null,
): boolean {
  return access === 'admin' && Boolean(currentUserId) && currentUserId === verifiedUserId
}

// When the admin flag must be checked (and kept fresh): Settings and admin pages show developer tools, and a developer
// feature switched on for this device (Screenshot Clean-up) needs authorization wherever it shows.
export function developerAccessNeeded(surfaces: { settingsOpen: boolean; adminRoute: boolean; cleanupRequested: boolean }): boolean {
  return surfaces.settingsOpen || surfaces.adminRoute || surfaces.cleanupRequested
}
